/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AdditionalQuestionDestroyPathParams,
	AdditionalQuestionDestroyResponse,
} from '../types/AdditionalQuestionDestroy'

/**
 * DELETE /additional-questions/:question
 * @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::destroy
 */
export async function additionalQuestionDestroy(
	question: AdditionalQuestionDestroyPathParams['question'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdditionalQuestionDestroyResponse>> {
	return axiosInstance.delete(`/additional-questions/${question}`, config)
}
